import src from "IMAGE";
export default { src, width: 58, height: 58, blurWidth: 0, blurHeight: 0};
